var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgesliver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6089_19419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4055 3.21099C39.9006 1.93693 42.0994 1.93694 43.5945 3.21099L49.8112 8.50882C50.4518 9.05478 51.2484 9.38473 52.0874 9.45169L60.2294 10.1014C62.1875 10.2577 63.7423 11.8125 63.8986 13.7706L64.5483 21.9126C64.6153 22.7516 64.9452 23.5482 65.4912 24.1888L70.789 30.4055C72.0631 31.9006 72.0631 34.0994 70.789 35.5945L65.4912 41.8112C64.9452 42.4518 64.6153 43.2484 64.5483 44.0874L63.8986 52.2294C63.7423 54.1875 62.1875 55.7423 60.2294 55.8986L52.0874 56.5483C51.2484 56.6153 50.4518 56.9452 49.8112 57.4912L43.5945 62.789C42.0994 64.0631 39.9006 64.0631 38.4055 62.789L32.1888 57.4912C31.5482 56.9452 30.7516 56.6153 29.9126 56.5483L21.7706 55.8986C19.8125 55.7423 18.2577 54.1875 18.1014 52.2294L17.4517 44.0874C17.3847 43.2484 17.0548 42.4518 16.5088 41.8112L11.211 35.5945C9.93693 34.0994 9.93694 31.9006 11.211 30.4055L16.5088 24.1888C17.0548 23.5482 17.3847 22.7516 17.4517 21.9126L18.1014 13.7706C18.2577 11.8125 19.8125 10.2577 21.7706 10.1014L29.9126 9.45169C30.7516 9.38473 31.5482 9.05478 32.1888 8.50882L38.4055 3.21099Z",
    fill: "url(#paint0_linear_6089_19419)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6089_19419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 58C54.8072 58 66.0001 46.8071 66.0001 33C66.0001 19.1929 54.8072 8 41 8C27.1929 8 16 19.1929 16 33C16 46.8071 27.1929 58 41 58Z",
    fill: "url(#paint1_linear_6089_19419)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M41 55C53.1503 55 63.0001 45.1503 63.0001 33C63.0001 20.8497 53.1503 11 41 11C28.8498 11 19 20.8497 19 33C19 45.1503 28.8498 55 41 55Z",
    fill: "url(#paint2_radial_6089_19419)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62 32.9261C62 33.7868 61.9508 34.6474 61.8523 35.4835C61.7538 36.4179 61.5569 37.3523 61.3353 38.2376C61.2368 38.631 61.1383 38.9999 61.0152 39.3933C60.7937 40.0818 60.5475 40.7704 60.2521 41.4343C59.612 42.8851 58.8242 44.2375 57.8886 45.4916C57.1008 46.549 56.2146 47.5326 55.2298 48.4424C51.5124 51.885 46.5393 53.9752 41.074 53.9998C35.6086 54.0244 30.6109 51.9588 26.8689 48.5408C25.9087 47.6556 25.0224 46.6966 24.2346 45.6638C22.7575 43.7212 21.625 41.5081 20.9111 39.1474C20.5664 38.0409 20.3202 36.8851 20.1725 35.7048C20.0741 34.8442 20.0002 33.9835 20.0002 33.1229C19.951 21.4672 29.3061 12.0492 40.9262 12C52.5217 11.9755 61.9508 21.3197 62 32.9261Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 54C52.598 54 62 44.598 62 33C62 21.402 52.598 12 41 12C29.402 12 20 21.402 20 33C20 44.598 29.402 54 41 54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 54C52.598 54 62 44.598 62 33C62 21.402 52.598 12 41 12C29.402 12 20 21.402 20 33C20 44.598 29.402 54 41 54Z",
    fill: "url(#paint3_linear_6089_19419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2734 32.2031C38.0547 32.2031 37.8464 32.1615 37.6484 32.0781C37.4557 31.9896 37.2865 31.875 37.1406 31.7344C36.9948 31.5885 36.8802 31.4193 36.7969 31.2266C36.7135 31.0286 36.6719 30.8203 36.6719 30.6016V27.3984C36.6719 27.1797 36.7135 26.974 36.7969 26.7812C36.8802 26.5833 36.9948 26.4141 37.1406 26.2734C37.2865 26.1276 37.4557 26.013 37.6484 25.9297C37.8464 25.8411 38.0547 25.7969 38.2734 25.7969H43.7109C43.9297 25.7969 44.1354 25.8411 44.3281 25.9297C44.526 26.013 44.6979 26.1276 44.8438 26.2734C44.9896 26.4141 45.1042 26.5833 45.1875 26.7812C45.2708 26.974 45.3125 27.1797 45.3125 27.3984V28.8438H43.7109V27.3984H38.2734V30.6016H43.7109C43.9297 30.6016 44.1354 30.6432 44.3281 30.7266C44.526 30.8099 44.6979 30.9245 44.8438 31.0703C44.9896 31.2161 45.1042 31.388 45.1875 31.5859C45.2708 31.7786 45.3125 31.9844 45.3125 32.2031V35.3984C45.3125 35.6172 45.2708 35.8255 45.1875 36.0234C45.1042 36.2161 44.9896 36.3854 44.8438 36.5312C44.6979 36.6771 44.526 36.7917 44.3281 36.875C44.1354 36.9583 43.9297 37 43.7109 37H38.1172C37.8984 37 37.6901 36.9583 37.4922 36.875C37.2995 36.7917 37.1302 36.6771 36.9844 36.5312C36.8385 36.3854 36.724 36.2161 36.6406 36.0234C36.5573 35.8255 36.5156 35.6172 36.5156 35.3984V33.9609H38.1172V35.3984H43.7109V32.2031H38.2734Z",
    fill: "url(#paint4_linear_6089_19419)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6089_19419",
    x: -1,
    y: -1,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0196078 0 0 0 0 0.2 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6089_19419"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6089_19419",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6089_19419",
    x: 10,
    y: 5,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0196078 0 0 0 0 0.2 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6089_19419"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6089_19419",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6089_19419",
    x1: 8.96529,
    y1: 32.9895,
    x2: 73.0138,
    y2: 32.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C2E8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6089_19419",
    x1: 15.9729,
    y1: 32.9918,
    x2: 66.0108,
    y2: 32.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C2E8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6089_19419",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.989 32.9889) scale(21.9893 21.9893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#571600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6089_19419",
    x1: 41,
    y1: 12,
    x2: 41,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6089_19419",
    x1: 34.9935,
    y1: 32.9974,
    x2: 47.0026,
    y2: 32.9974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#D3D9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#4A4A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#929190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgesliver);
export default __webpack_public_path__ + "static/media/badgesliver.2a8cf2fed98f3d1cdee16ae0f915a5ed.svg";
export { ForwardRef as ReactComponent };